import React from "react";
import Utils from "Utils/utils";
import { observer } from "mobx-react";
import linkedInUtils from "./common/linkedInUtils";

const ReconnectLinkedInButton = observer(
  ({ accountId, hasLiCookie = false, isPremium = false } = {}) => {
    return (
      <div className="btnInboxActions">
        <span
          className="reconnectBtn"
          onClick={e => {
            Utils.preventDefaultFn(e);
            if (hasLiCookie) {
              linkedInUtils.connectViaExtension(isPremium, true);
            } else {
              linkedInUtils.connectViaOAuth(accountId);
            }
          }}
        >
          Reconnect
        </span>
      </div>
    );
  }
);

export default ReconnectLinkedInButton;
